import { Section } from './Section';

export default Section;
